<div class="container mx-auto gap-4 px-4 md:px-6 pt-8 pb-4">
  <div class="flex flex-wrap items-center gap-2 mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Signalering</h2>
    @if (blocks().length > 0) {
      <button
        *appHasPermission="'scm:create'"
        mat-button
        class="sm:ml-auto"
        [matMenuTriggerFor]="blockMenu"
        [disabled]="!canAddBlock()"
      >
        <mat-icon>add</mat-icon>

        Nieuw blok
      </button>
    }
  </div>

  <div class="flex flex-col gap-12" #blocksContainer>
    @for (block of blocks(); track $index) {
      @if (block.type === 'audio') {
        <div class="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-4">
          <div class="flex flex-col rounded-lg p-4 pb-1.5">
            <app-signaling-block-avatar
              [src]="block.avatarUrl"
              [disabled]="block.active || !canUpdateScm()"
              (imageChange)="handleBlockAvatarChange(block)"
            />

            <div class="text-sm py-4 space-y-2">
              <div>
                <span class="font-medium">Status:</span>

                {{ block.active ? 'Actief' : 'Inactief' }}
              </div>

              <div>
                <span class="font-medium">Aantal kliks:</span>

                {{ block.logCount }}
              </div>

              <div>
                <span class="font-medium">Afspeel type:</span>

                {{ block.config.type | mapFrom: blockConfigTypeMap[block.type] }}
              </div>
            </div>

            <div class="flex flex-wrap gap-2 -ml-3 mt-6">
              <ng-container *appHasPermission="'scm:update'">
                @if (block.active) {
                  <button
                    mat-stroked-button
                    (click)="handleBlockActiveChange(block._id, false)"
                  >
                    Deactiveren
                  </button>
                } @else {
                  <button
                    mat-flat-button
                    [disabled]="!canBlockActivate(block)"
                    (click)="handleBlockActiveChange(block._id, true)"
                  >
                    Activeren
                  </button>
                }
              </ng-container>

              <button
                *appHasPermission="'scm:delete'"
                mat-button
                (click)="handleBlockRemove(block)"
                [disabled]="block.active"
              >
                Verwijderen
              </button>
            </div>
          </div>
          <div class="flex flex-col bg-white rounded-lg h-min">
            <div class="flex items-center p-4 border-b border-gray-200 select-none">
              <h3 class="text-lg font-medium">
                Audio
                <span class="text-gray-500"
                  >({{ block.data.length }}/{{ maxBlockReferenceLength }})</span
                >
              </h3>
              <div class="ml-auto">
                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Audio toevoegen"
                  [disabled]="
                    block.active || block.data.length >= maxBlockReferenceLength
                  "
                  (click)="handleBlockItemAdd(block)"
                >
                  <mat-icon>add</mat-icon>
                </button>

                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Blok configureren"
                  [disabled]="block.active"
                  (click)="handleBlockConfigChange(block)"
                >
                  <mat-icon>settings</mat-icon>
                </button>
              </div>
            </div>

            <div class="p-4 flex-auto">
              <app-signaling-block-audio-table
                [dataSource]="block.data"
                [hideActions]="block.active || !canUpdateScm()"
                (itemRemove)="handleBlockItemRemove(block, $event)"
              />
            </div>
          </div>
        </div>
      }
      @if (block.type === 'image') {
        <div class="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-4">
          <div class="flex flex-col rounded-lg p-4 pb-1.5">
            <app-signaling-block-avatar
              [src]="block.avatarUrl"
              [disabled]="block.active || !canUpdateScm()"
              (imageChange)="handleBlockAvatarChange(block)"
            />

            <div class="text-sm py-4 space-y-2">
              <div>
                <span class="font-medium">Status:</span>

                {{ block.active ? 'Actief' : 'Inactief' }}
              </div>

              <div>
                <span class="font-medium">Aantal kliks:</span>

                {{ block.logCount }}
              </div>

              <div>
                <span class="font-medium">Afspeel type:</span>

                {{ block.config.type | mapFrom: blockConfigTypeMap[block.type] }}
              </div>

              @if (block.config.type === 'slideshow') {
                <div>
                  <span class="font-medium">Duratie per slide:</span>

                  {{ block.config.slideDuration }} seconden
                </div>
              }
            </div>

            <div class="flex flex-wrap gap-2 -ml-3 mt-6">
              <ng-container *appHasPermission="'scm:update'">
                @if (block.active) {
                  <button
                    mat-stroked-button
                    (click)="handleBlockActiveChange(block._id, false)"
                  >
                    Deactiveren
                  </button>
                } @else {
                  <button
                    mat-flat-button
                    [disabled]="!canBlockActivate(block)"
                    (click)="handleBlockActiveChange(block._id, true)"
                  >
                    Activeren
                  </button>
                }
              </ng-container>

              <button
                *appHasPermission="'scm:delete'"
                mat-button
                (click)="handleBlockRemove(block)"
                [disabled]="block.active"
              >
                Verwijderen
              </button>
            </div>
          </div>
          <div class="flex flex-col bg-white rounded-lg h-min">
            <div class="flex items-center p-4 border-b border-gray-200 select-none">
              <h3 class="text-lg font-medium">
                Afbeeldingen
                <span class="text-gray-500"
                  >({{ block.data.length }}/{{ maxBlockReferenceLength }})</span
                >
              </h3>

              <div class="ml-auto">
                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Afbeeldingen toevoegen"
                  [disabled]="
                    block.active || block.data.length >= maxBlockReferenceLength
                  "
                  (click)="handleBlockItemAdd(block)"
                >
                  <mat-icon>add</mat-icon>
                </button>

                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Blok configureren"
                  [disabled]="block.active"
                  (click)="handleBlockConfigChange(block)"
                >
                  <mat-icon>settings</mat-icon>
                </button>
              </div>
            </div>

            <div class="p-4 flex-auto">
              <app-signaling-block-image-table
                [dataSource]="block.data"
                [hideActions]="block.active || !canUpdateScm()"
                (itemRemove)="handleBlockItemRemove(block, $event)"
              />
            </div>
          </div>
        </div>
      }
      @if (block.type === 'interaction') {
        <div class="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-4">
          <div class="flex flex-col rounded-lg p-4 pb-1.5">
            <app-signaling-block-avatar
              [src]="block.avatarUrl"
              [disabled]="block.active || !canUpdateScm()"
              (imageChange)="handleBlockAvatarChange(block)"
            />

            <div class="text-sm py-4 space-y-2">
              <div>
                <span class="font-medium">Status:</span>

                {{ block.active ? 'Actief' : 'Inactief' }}
              </div>

              <div>
                <span class="font-medium">Aantal kliks:</span>

                {{ block.logCount }}
              </div>
            </div>

            <div class="flex flex-wrap gap-2 -ml-3 mt-6">
              <ng-container *appHasPermission="'scm:update'">
                @if (block.active) {
                  <button
                    mat-stroked-button
                    (click)="handleBlockActiveChange(block._id, false)"
                  >
                    Deactiveren
                  </button>
                } @else {
                  <button
                    mat-flat-button
                    [disabled]="!canBlockActivate(block)"
                    (click)="handleBlockActiveChange(block._id, true)"
                  >
                    Activeren
                  </button>
                }
              </ng-container>

              <button
                *appHasPermission="'scm:delete'"
                mat-button
                (click)="handleBlockRemove(block)"
                [disabled]="block.active"
              >
                Verwijderen
              </button>
            </div>
          </div>
          <div class="flex flex-col bg-white rounded-lg h-min">
            <div class="flex items-center p-4 border-b border-gray-200 select-none">
              <h3 class="text-lg font-medium">
                Interacties
                <span class="text-gray-500"
                  >({{ block.data.length }}/{{ maxBlockReferenceLength }})</span
                >
              </h3>
              <div class="ml-auto">
                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Interacties toevoegen"
                  [disabled]="
                    block.active || block.data.length >= maxBlockReferenceLength
                  "
                  (click)="handleBlockItemAdd(block)"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <div class="p-4 flex-auto">
              <app-signaling-block-interaction-table
                [dataSource]="block.data"
                [hideActions]="block.active || !canUpdateScm()"
                [hideFlowButton]="!canReadInteraction()"
                (itemRemove)="handleBlockItemRemove(block, $event)"
              />
            </div>
          </div>
        </div>
      }
      @if (block.type === 'folder') {
        <div class="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-4">
          <div class="flex flex-col rounded-lg p-4 pb-1.5">
            <app-signaling-block-avatar
              [src]="block.avatarUrl"
              [disabled]="block.active || !canUpdateScm()"
              (imageChange)="handleBlockAvatarChange(block)"
            />

            <div class="text-sm py-4 space-y-2">
              <div>
                <span class="font-medium">Status:</span>

                {{ block.active ? 'Actief' : 'Inactief' }}
              </div>

              <div>
                <span class="font-medium">Aantal kliks:</span>

                {{ block.logCount }}
              </div>

              <div
                class="font-medium inline-flex items-center gap-1"
                [class.text-red-600]="block.matchingInteractionCount === 0"
              >
                {{ block.matchingInteractionCount }}
                {{ block.matchingInteractionCount === 1 ? 'interactie' : 'interacties' }}
                gevonden

                <mat-icon
                  class="text-black !text-base !w-4 !h-4 !leading-none cursor-context-menu"
                  matTooltip="Dit aantal geeft aan hoeveel gepubliceerde interacties overeenkomen met alle geselecteerde tags.&#10;&#10;Als dit 0 is, zal dit blok niet zichtbaar zijn op de robot."
                  matTooltipClass="whitespace-pre-line"
                  matTooltipPosition="after"
                >help_outline</mat-icon>
              </div>
            </div>

            <div class="flex flex-wrap gap-2 -ml-3 mt-6">
              <ng-container *appHasPermission="'scm:update'">
                @if (block.active) {
                  <button
                    mat-stroked-button
                    (click)="handleBlockActiveChange(block._id, false)"
                  >
                    Deactiveren
                  </button>
                } @else {
                  <button
                    mat-flat-button
                    [disabled]="!canBlockActivate(block)"
                    (click)="handleBlockActiveChange(block._id, true)"
                  >
                    Activeren
                  </button>
                }
              </ng-container>

              <button
                *appHasPermission="'scm:delete'"
                mat-button
                (click)="handleBlockRemove(block)"
                [disabled]="block.active"
              >
                Verwijderen
              </button>
            </div>
          </div>
          <div class="flex flex-col bg-white rounded-lg h-min">
            <div class="flex items-center p-4 border-b border-gray-200 select-none">
              <h3 class="text-lg font-medium">
                Tags
                <span class="text-gray-500"
                  >({{ block.data.length }}/{{ maxBlockReferenceLength }})</span
                >
              </h3>
              <div class="ml-auto">
                <button
                  *appHasPermission="'scm:update'"
                  mat-icon-button
                  class="inline-flex!"
                  matTooltip="Tags toevoegen"
                  [disabled]="
                    block.active || block.data.length >= maxBlockReferenceLength
                  "
                  (click)="handleBlockItemAdd(block)"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <div class="p-4 flex-auto">
              <app-signaling-block-folder-table
                [dataSource]="block.data"
                [hideActions]="block.active || !canUpdateScm()"
                (itemRemove)="handleBlockItemRemove(block, $event)"
              />
            </div>
          </div>
        </div>
      }
    } @empty {
      <app-empty-state-placeholder
        icon="leak_add"
        heading="Je hebt nog geen signaleringsblokken"
        message="Maak je eerste blok aan om afbeeldingen, audio, interacties of tags te delen met de cliënt."
      >
        <button *appHasPermission="'scm:create'" mat-flat-button ngProjectAs="button" [matMenuTriggerFor]="blockMenu">
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>

          <span>Nieuw blok maken</span>
        </button>
      </app-empty-state-placeholder>
    }
  </div>

  <mat-menu #blockMenu="matMenu">
    @for (item of blockCreateMenuItems; track $index) {
      <button mat-menu-item (click)="handleBlockCreate(item.type)">
        <mat-icon>{{ item.icon }}</mat-icon>

        {{ item.value }}
      </button>
    }
  </mat-menu>
</div>
